<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title :title="getMessage_(screen.menuTitle)" useFavorite :favorite="screen.favoriteYn === 'Y'" :onFavorite="onFavorite" />
		</template>
		<template v-slot:content>
			<pc-ro-list-content
				ref="content"
				:scrId="scrId"
				:pStartDt="pStartDt"
				:pEndDt="pEndDt"
				:pStartDt2="pStartDt2"
				:pEndDt2="pEndDt2"
				:pState1="pState1"
				:pState2="pState2"
				:pState3="pState3"
				:pState4="pState4"
				:pState5="pState5"
				:pState6="pState6"
				:pState7="pState7"
				:pState8="pState8"
				:pState9="pState9"
				:pState10="pState10"
				:pState11="pState11"
				:pState12="pState12"
				:pState13="pState13"
				:pState14="pState14"
				:pState15="pState15"
				:pState16="pState16"
				:pState17="pState17"
				:pState18="pState18"
			></pc-ro-list-content>
		</template>
	</sf-content-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/clma/PcRoList/store/helpers';
import PcRoListContent from './Content/PcRoListContent.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' }, //판매 시작월
		pEndDt: { type: String, default: '' }, //판매 종료월
		pStartDt2: { type: String, default: '' }, //조건 시작월
		pEndDt2: { type: String, default: '' }, //조건 종료월
		pState1: { type: String, default: '' }, //부품유형
		pState2: { type: String, default: '' }, //차량구분
		pState3: { type: String, default: '' }, //승상구분
		pState4: { type: String, default: '' }, //연료전지사양
		pState5: { type: String, default: '' }, //판매지역
		pState6: { type: String, default: '' }, //사용기간(3m,12m,WM)
		pState7: { type: String, default: '' }, //RO처리단계
		pState8: { type: String, default: '' }, //RO처리결과
		pState9: { type: String, default: '' }, //Ctype
		pState10: { type: String, default: '' }, //차종유형
		pState11: { type: String, default: '' }, //판매월검색조건 HTWO판매월
		pState12: { type: String, default: '' }, //검색조건 조건월
		pState13: { type: String, default: '' }, //검색조건 사용기간(년)
		pState14: { type: String, default: '' }, //지수구분
		pState15: { type: String, default: '' }, //현상코드
		pState16: { type: String, default: '' }, //누적
		pState17: { type: String, default: '' }, //품번
		pState18: { type: String, default: '' } //정비유형
	},
	created() {
		//화면진입시 초기화
		this.setStateInit_();
		this.screen = this.screenArray.get(this.scrId);
		//console.clear();
	},
	components: {
		PcRoListContent
	},
	data() {
		return {
			title: 'R/O리스트',
			favorite: true,
			screen: {}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
